import React from "react";
import img1 from '../../images/conditionHomeDesktop.png';

const ConditionSection = () => {
    return(
    <div className="condition-section">
        <div className="condition-section-box condition-section-text">
        <h1 className="condition-section-heading">
            Find what you’re looking for in less than 2 minutes.
        </h1>
        <div className="condition-blue-line"></div>
        <p className="condition-section-para">
            We’ve integrated a smart search so that you can always find the
            condition or clinical sign that you’re looking for.
        </p>
        </div>
        <div className="condition-section-box condition-section-img">
        <img src={img1} alt=""/>
        </div>
    </div>
    )
}
export default ConditionSection;